import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const StyledCardImage = styled.img`
  height: auto;
  width: 100%;
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'alt' implicitly has an 'any' type.
const CardImage = ({ src = '/images/car-image-not-found.svg', alt }) => <StyledCardImage {...{ src, alt }} />;

export default CardImage;

CardImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
};
